import React, { Component } from 'react';

class Interests extends Component {
    render() {
        return (
            <article>
                <p>I love learning about almost everything. These are 
                    some areas where I would like to learn more about
                </p>
                <ul>
                    <li>Computer Animation</li>
                    <li>Video Recording</li>
                    <li>Robotic</li>
                    <li>Deep learning</li>
                </ul>
            </article>
        )
    }
}

export default Interests;